export const Bharuch = {
    title: "Bharuch",
    title1: "(Ancient Port City)",

    attractions: [
        {
            name: "Narmada Riverfront",
            description: "The Narmada Riverfront is a serene and picturesque spot in Bharuch, offering breathtaking views of the river and the surrounding landscape. It is a popular place for locals and tourists to relax, take a stroll, and enjoy the natural beauty.",
            location: "Narmada Riverfront, Bharuch",
            timings: "Open 24 hours",
            ticket: "Free Entry",
            bestTimeToVisit: "Early Morning or Evening",
            activities: [
                "Take a peaceful walk along the river",
                "Enjoy the scenic views",
                "Photography",
                "Attend evening aarti (prayer ceremony)",
                "Relax and unwind"
            ],
            mapLink: "https://maps.app.goo.gl/examplelink1",
        },
        {
            name: "Bharuch Fort",
            description: "A historic fort located in the heart of Bharuch, this structure dates back to the Mughal era and offers a glimpse into the city's rich history. The fort is known for its impressive architecture and strategic location.",
            location: "Bharuch Fort, Bharuch",
            timings: "9:00 AM to 6:00 PM",
            ticket: "Free Entry",
            bestTimeToVisit: "Morning or Afternoon",
            activities: [
                "Explore the fort's architecture",
                "Learn about its historical significance",
                "Photography",
                "Enjoy the panoramic views of the city",
                "Visit nearby attractions"
            ],
            mapLink: "https://maps.app.goo.gl/examplelink2",
        },
        {
            name: "Golden Bridge",
            description: "The Golden Bridge, also known as the Narmada Bridge, is an iconic landmark in Bharuch. It connects Bharuch to Ankleshwar and offers stunning views of the Narmada River, especially during sunrise and sunset.",
            location: "Golden Bridge, Bharuch",
            timings: "Open 24 hours",
            ticket: "Free Entry",
            bestTimeToVisit: "Sunrise or Sunset",
            activities: [
                "Admire the bridge's architecture",
                "Enjoy the views of the Narmada River",
                "Photography",
                "Take a leisurely drive across the bridge",
                "Watch the sunset"
            ],
            mapLink: "https://maps.app.goo.gl/examplelink3",
        },
        {
            name: "Shuklatirth Temple",
            description: "A sacred Jain temple located on the banks of the Narmada River, Shuklatirth Temple is known for its spiritual significance and serene ambiance. The temple is a popular pilgrimage site for Jains and tourists alike.",
            location: "Shuklatirth, Bharuch",
            timings: "6:00 AM to 8:00 PM",
            ticket: "Free Entry",
            bestTimeToVisit: "Morning or Evening",
            activities: [
                "Attend morning and evening prayers",
                "Admire the temple's architecture",
                "Experience the peaceful atmosphere",
                "Learn about Jainism",
                "Visit the nearby ghats"
            ],
            mapLink: "https://maps.app.goo.gl/examplelink4",
        },
        {
            name: "Kaliya Bhairo Temple",
            description: "A historic temple dedicated to Lord Bhairo, this site is known for its spiritual significance and unique architecture. The temple attracts devotees and tourists seeking blessings and peace.",
            location: "Kaliya Bhairo Temple, Bharuch",
            timings: "6:00 AM to 8:00 PM",
            ticket: "Free Entry",
            bestTimeToVisit: "Morning or Evening",
            activities: [
                "Attend prayers and rituals",
                "Admire the temple's architecture",
                "Experience the spiritual ambiance",
                "Learn about the temple's history",
                "Visit nearby attractions"
            ],
            mapLink: "https://maps.app.goo.gl/examplelink5",
        },
        {
            name: "Kabirvad",
            description: "A serene island located on the Narmada River, Kabirvad is known for its massive banyan tree and spiritual significance. The island is named after the famous saint Kabir and is a peaceful retreat for nature lovers and spiritual seekers.",
            location: "Kabirvad, Bharuch",
            timings: "8:00 AM to 6:00 PM",
            ticket: "Free Entry",
            bestTimeToVisit: "Morning or Afternoon",
            activities: [
                "Explore the massive banyan tree",
                "Enjoy the peaceful environment",
                "Take a boat ride to the island",
                "Meditate and relax",
                "Photography"
            ],
            mapLink: "https://maps.app.goo.gl/examplelink6",
        },
        {
            name: "Bhrigu Rishi Temple",
            description: "A historic temple dedicated to Sage Bhrigu, this site is located on the banks of the Narmada River and is known for its spiritual significance. The temple attracts devotees and tourists seeking blessings and peace.",
            location: "Bhrigu Rishi Temple, Bharuch",
            timings: "6:00 AM to 8:00 PM",
            ticket: "Free Entry",
            bestTimeToVisit: "Morning or Evening",
            activities: [
                "Attend prayers and rituals",
                "Admire the temple's architecture",
                "Experience the spiritual ambiance",
                "Learn about the temple's history",
                "Visit nearby attractions"
            ],
            mapLink: "https://maps.app.goo.gl/examplelink7",
        },
        {
            name: "Gandhi Smruti",
            description: "A memorial dedicated to Mahatma Gandhi, this site is located in Bharuch and showcases his life and teachings. The memorial is a place of inspiration and reflection for visitors.",
            location: "Gandhi Smruti, Bharuch",
            timings: "9:00 AM to 6:00 PM",
            ticket: "Free Entry",
            bestTimeToVisit: "Morning or Afternoon",
            activities: [
                "Learn about Gandhi's life and teachings",
                "Explore the exhibits",
                "Attend cultural events",
                "Photography",
                "Reflect and meditate"
            ],
            mapLink: "https://maps.app.goo.gl/examplelink8",
        },
        {
            name: "Bharuch Museum",
            description: "A small but fascinating museum in Bharuch, this site showcases the city's rich history, culture, and heritage. The museum houses artifacts, sculptures, and documents related to Bharuch's past.",
            location: "Bharuch Museum, Bharuch",
            timings: "10:00 AM to 5:00 PM",
            ticket: "Nominal Fee",
            bestTimeToVisit: "Afternoon",
            activities: [
                "Explore the exhibits",
                "Learn about Bharuch's history",
                "Admire ancient artifacts",
                "Photography",
                "Visit nearby attractions"
            ],
            mapLink: "https://maps.app.goo.gl/examplelink9",
        },
        {
            name: "Jageshwar Mahadev Temple",
            description: "A historic temple dedicated to Lord Shiva, this site is known for its spiritual significance and beautiful architecture. The temple attracts devotees and tourists seeking blessings and peace.",
            location: "Jageshwar Mahadev Temple, Bharuch",
            timings: "6:00 AM to 8:00 PM",
            ticket: "Free Entry",
            bestTimeToVisit: "Morning or Evening",
            activities: [
                "Attend prayers and rituals",
                "Admire the temple's architecture",
                "Experience the spiritual ambiance",
                "Learn about the temple's history",
                "Visit nearby attractions"
            ],
            mapLink: "https://maps.app.goo.gl/examplelink10",
        },
        {
            name: "Sardar Patel Park",
            description: "A beautiful park in Bharuch, this site is perfect for families and nature lovers. The park offers lush greenery, walking trails, and a peaceful environment.",
            location: "Sardar Patel Park, Bharuch",
            timings: "6:00 AM to 8:00 PM",
            ticket: "Free Entry",
            bestTimeToVisit: "Early Morning or Evening",
            activities: [
                "Take a walk in the park",
                "Enjoy birdwatching",
                "Have a picnic",
                "Photography",
                "Relax in the serene environment"
            ],
            mapLink: "https://maps.app.goo.gl/examplelink11",
        },
        {
            name: "Bharuch Bazaar",
            description: "A bustling market in the heart of Bharuch, this place is perfect for shopping and experiencing the local culture. From traditional Gujarati attire to handicrafts, the market offers a wide range of products.",
            location: "Bharuch Bazaar, Bharuch",
            timings: "10:00 AM to 9:00 PM",
            ticket: "Free Entry",
            bestTimeToVisit: "Evening",
            activities: [
                "Shop for traditional Gujarati items",
                "Try local street food",
                "Experience the vibrant atmosphere",
                "Buy souvenirs",
                "Interact with local vendors"
            ],
            mapLink: "https://maps.app.goo.gl/examplelink12",
        },
        {
            name: "Anand Mangal Mahadev Temple",
            description: "A historic temple dedicated to Lord Shiva, this site is known for its spiritual significance and beautiful architecture. The temple attracts devotees and tourists seeking blessings and peace.",
            location: "Anand Mangal Mahadev Temple, Bharuch",
            timings: "6:00 AM to 8:00 PM",
            ticket: "Free Entry",
            bestTimeToVisit: "Morning or Evening",
            activities: [
                "Attend prayers and rituals",
                "Admire the temple's architecture",
                "Experience the spiritual ambiance",
                "Learn about the temple's history",
                "Visit nearby attractions"
            ],
            mapLink: "https://maps.app.goo.gl/examplelink13",
        },
        {
            name: "Swaminarayan Temple",
            description: "A beautiful temple dedicated to Lord Swaminarayan, this spiritual site is known for its intricate architecture and serene ambiance. It is a popular place for devotees and tourists seeking peace and spiritual solace.",
            location: "Swaminarayan Temple, Bharuch",
            timings: "6:00 AM to 8:00 PM",
            ticket: "Free Entry",
            bestTimeToVisit: "Early Morning or Evening",
            activities: [
                "Attend morning and evening prayers",
                "Admire the temple's architecture",
                "Participate in religious discourses",
                "Enjoy the peaceful atmosphere",
                "Visit the nearby garden"
            ],
            mapLink: "https://maps.app.goo.gl/examplelink14",
        },
        {
            name: "Bharuch Science Centre",
            description: "A popular destination for science enthusiasts, the Bharuch Science Centre offers interactive exhibits and educational programs. The center is a great place for both kids and adults to learn about science and technology.",
            location: "Bharuch Science Centre, Bharuch",
            timings: "10:00 AM to 6:00 PM",
            ticket: "Nominal Fee",
            bestTimeToVisit: "Afternoon",
            activities: [
                "Explore interactive exhibits",
                "Attend science workshops",
                "Learn about scientific concepts",
                "Participate in educational programs",
                "Visit the planetarium"
            ],
            mapLink: "https://maps.app.goo.gl/examplelink15",
        },
    ]
};